import { Amplify } from "aws-amplify";

export function configureAmplifyClient() {
  if (typeof window === "undefined") return;
  if (typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap") return;

  Amplify.configure({
    Auth: {
      Cognito: {
        region: "eu-west-1",
        userPoolId: "eu-west-1_KelTbgxEJ",
        userPoolClientId: "4jm223eamlc19sekt0m3ts7c2k",
        loginWith: {
          oauth: {
            domain: "dev-backendhelpers-login.auth.eu-west-1.amazoncognito.com",
            scopes: ["email", "openid", "profile"],
            redirectSignIn: [
              "https://www.dev.backendhelpers.co"
            ],
            redirectSignOut: [
              "https://www.dev.backendhelpers.co/logout",
            ],
            responseType: "code",
          },
        },
      },
    },
  });
}
